import React, { useEffect, useState } from 'react'
import subscribeToChannel from '../../channels/subscribe_to_channel'

import Router from './PublicRouter'

const OBS_STATE_CONTROL_CHANNEL = 'ObsStateControlChannel'
const PLAYERS_CHANNEL = 'PlayersIndexChannel'
// const CONTROL_PANEL_PATH_ROOT = '/controlpanel'
// const CONTROL_PANEL_PATH_ROOT = '/'

import { readSettingsCookie } from '../utils'
import { useStore } from '../zustandStore'
import { shallow } from 'zustand/shallow'

const PublicApp = (props)  => {
  const {
    isBingo,
    setPlayers,
    setPlayersNew, // TEMP PLAYERS_NEW
    setBrackets,
    setDivisions,
    setNonBracketParticipantPlayerSlugs,
    setObsState,
    setPublicAppSettings,
    publicSubmissions,
    handleNewPublicSubmissionBatch,
    decrementPublicSubmissionsOffset,
  } = useStore(
    state => ({
      isBingo: state.event.isBingo,
      setPlayers: state.setPlayers,
      setPlayersNew: state.setPlayersNew,  // TEMP PLAYERS_NEW
      setBrackets: state.setBrackets,
      setDivisions: state.setDivisions,
      setNonBracketParticipantPlayerSlugs: state.setNonBracketParticipantPlayerSlugs,
      setObsState: state.setObsState,
      setPublicAppSettings: state.setPublicAppSettings,
      publicSubmissions: state.publicSubmissions,
      handleNewPublicSubmissionBatch: state.handleNewPublicSubmissionBatch,
      decrementPublicSubmissionsOffset: state.decrementPublicSubmissionsOffset,
    })
  )
  const event = useStore((state => state.event), shallow)

  const handlePlayersUpdate = message => {
    // console.log({message})
    setPlayers(message.players)
    setPlayersNew(message.playersNew) // TEMP PLAYERS_NEW
    setDivisions(message.divisions)
    setBrackets(message.brackets)
    setNonBracketParticipantPlayerSlugs(message.nonBracketParticipantPlayerSlugs)

    if (!isBingo) handleNewPublicSubmissionBatch(message.submissions)
  }

  useEffect(() => {
    if (isBingo) return
    // console.log('useEffect ran')
    if (window.publicSubmissionsPollingInterval == null) {
      // console.log('polling interval set')
      window.publicSubmissionsPollingInterval = window.setInterval(() => {
        // console.log('decrement happened')
        decrementPublicSubmissionsOffset()
      }, 1500)
    }
  }, [publicSubmissions[0] && publicSubmissions[0].id])

  const { isActive, isConcluded, isFullGame } = event
  if (isActive && !isConcluded) {
    useEffect(() => {
      subscribeToChannel(PLAYERS_CHANNEL, handlePlayersUpdate)
    }, [])
  } else {
    console.log('Did not subscribe to live updates, event is inactive/concluded')
  }

  // public app stores user facing settings in cookies. so we load them here on first load
  useEffect(() => {
    const settingsFromCookies = readSettingsCookie()
    setPublicAppSettings(settingsFromCookies)
  }, [])


  const handleObsStateUpdate = message => {
    if (message.force === 'reload') {
      // force reload message for browser sources, public app should ignore
      return
    }

    const { obsState } = message
    setObsState({
      ...obsState,
      loadedAtMs: Date.now()
    })
  }

  // let controlPanelProps = {}
  // if (window.location.pathname.startsWith(CONTROL_PANEL_PATH_ROOT)) {
    // controlPanelProps = { obsState: obsState }
    // if (!isFullGame) {
      if (isActive && !isConcluded) {
        useEffect(() => { window.obsSubscription = subscribeToChannel(OBS_STATE_CONTROL_CHANNEL, handleObsStateUpdate) }, [])
      } else {
        console.log('Did not subscribe to live updates, event is inactive/concluded')
      }
    // }
  // }
  // const playersStore = useStore(state => state.players)
  return <Router />
}

export default PublicApp
